import { Component, OnInit } from '@angular/core';
import { AppConstants } from 'src/app/app.constants';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

  modulo: any = AppConstants.APLICATION_SUBMODULES.ERROR;

  constructor(private utils: UtilsService) { }

  ngOnInit(): void {
  }

  redirectInicio() {
    this.utils.redirectPathWindow(AppConstants.APLICATION_MODULES.INICIO.ruta);
  }

}
